export class NavigationRoute {
  static readonly EMPTY = '';
  static readonly BY_ID = ':id';
  static readonly LOGIN = 'login';
  static readonly RESET_PASSWORD = 'reset-password';
  static readonly REQUEST_RESET_PASSWORD = 'request-reset-password';
  static readonly AUTH = 'auth';
  static readonly ADMIN = 'admin';
  static readonly USERS = 'users';
  static readonly CLIENTS = 'clients';
  static readonly SIGNATURES = 'signatures';
  static readonly RESULT = 'results';
  static readonly PATIENT_EXAMS = 'patient-exams';
  static readonly PATIENT_INFO = 'patient-info';
  static readonly DOMAIN = 'domains';


}
